export const columns = [
  {
    title: "Posição",
    key: "rank",
    sortable: false
  },
  {
    title: "País",
    key: "name",
    sortable: false
  },
  {
    title: "Ouro",
    key: "gold_medals",
    sortable: false
  },
  {
    title: "Prata",
    key: "silver_medals",
    sortable: false
  },
  {
    title: "Bronze",
    key: "bronze_medals",
    sortable: false
  },
  {
    title: "Total",
    key: "total_medals",
    align: "center",
    sortable: false
  },
];
